// SCR-CONSOLE-009 — Audit پلتفرم (US-PLT-083): فیلتر مستأجر، اقدام (پیشوند با * پایانی)، کاربر و بازه؛ جزئیات قبل و بعد.
import Button from '@mui/material/Button';
import Stack from '@mui/material/Stack';
import { useTranslation } from '@phoenix/i18n';
import { JalaliDatePickerRHF, ListPage, TextFieldRHF } from '@phoenix/ui';
import { useState } from 'react';
import { useForm } from 'react-hook-form';
import { startOfBusinessDayIso } from '../../dates';
import { AuditTable, type AuditFilters } from './AuditTable';

export const SCR_CONSOLE_009 = 'SCR-CONSOLE-009';

interface FilterForm {
  tenantId: string;
  action: string;
  actorId: string;
  from: string | null;
  to: string | null;
}

const UUID = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;

function toFilters(values: FilterForm): AuditFilters {
  return {
    tenantId: UUID.test(values.tenantId.trim()) ? values.tenantId.trim() : undefined,
    action: values.action.trim() || undefined,
    actorId: UUID.test(values.actorId.trim()) ? values.actorId.trim() : undefined,
    from: values.from ? startOfBusinessDayIso(values.from) : undefined,
    to: values.to ? startOfBusinessDayIso(values.to, undefined, 1) : undefined,
  };
}

export function AuditPage() {
  const { t } = useTranslation('console');
  const [filters, setFilters] = useState<AuditFilters>({});
  const { control, handleSubmit, reset } = useForm<FilterForm>({
    defaultValues: { tenantId: '', action: '', actorId: '', from: null, to: null },
  });

  return (
    <ListPage screenId={SCR_CONSOLE_009} titleKey="console:audit.title" subtitleKey="console:audit.subtitle">
      <AuditTable
        filters={filters}
        toolbar={
          <Stack
            component="form"
            noValidate
            direction={{ xs: 'column', lg: 'row' }}
            spacing={1.5}
            alignItems={{ lg: 'flex-start' }}
            onSubmit={(event) => void handleSubmit((values) => setFilters(toFilters(values)))(event)}
            data-testid="audit-filters"
          >
            <TextFieldRHF
              control={control}
              name="tenantId"
              labelKey="console:audit.filters.tenant_id"
              slotProps={{ htmlInput: { dir: 'ltr' } }}
            />
            <TextFieldRHF
              control={control}
              name="action"
              labelKey="console:audit.filters.action"
              helperKey="console:audit.filters.action_help"
              slotProps={{ htmlInput: { dir: 'ltr' } }}
            />
            <TextFieldRHF
              control={control}
              name="actorId"
              labelKey="console:audit.filters.actor_id"
              slotProps={{ htmlInput: { dir: 'ltr' } }}
            />
            <JalaliDatePickerRHF control={control} name="from" labelKey="console:audit.filters.from" />
            <JalaliDatePickerRHF control={control} name="to" labelKey="console:audit.filters.to" />
            <Stack direction="row" spacing={1} sx={{ pt: 0.5 }}>
              <Button type="submit" variant="contained" data-testid="audit-apply">
                {t('common:actions.search')}
              </Button>
              <Button
                onClick={() => {
                  reset();
                  setFilters({});
                }}
              >
                {t('common:actions.clear')}
              </Button>
            </Stack>
          </Stack>
        }
      />
    </ListPage>
  );
}
